import { useEffect, useRef } from "react";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { useGetEmbeddedSupersetData } from "src/api/superset.ts";
import { Loading } from "src/components/utils/Loading.tsx";

type SupersetDashboardEmbedProps = {
    dashboardUuid: string;
};

export const SupersetDashboardEmbed = ({ dashboardUuid }: SupersetDashboardEmbedProps) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    const { data: embeddedData, isLoading } = useGetEmbeddedSupersetData({
        resources: [{ type: "dashboard", id: dashboardUuid }],
    });

    useEffect(() => {
        if (isLoading || !embeddedData || !containerRef.current) {
            return;
        }

        const mountPoint = containerRef.current;
        embedDashboard({
            id: dashboardUuid,
            supersetDomain: embeddedData.hostUrl,
            mountPoint,
            fetchGuestToken: async () => {
                return embeddedData.guestToken.guestToken;
            },
            dashboardUiConfig: {
                hideTitle: true,
                hideTab: true,
                hideChartControls: true,
                urlParams: embeddedData.urlParams,
                filters: {
                    visible: true,
                },
            },
        });

        const iframe = mountPoint.querySelector("iframe");
        if (iframe) {
            iframe.style.height = "100%";
            iframe.style.width = "100%";
            iframe.style.border = "none";
        }
    }, [dashboardUuid, embeddedData, isLoading]);

    if (isLoading) {
        return <Loading />;
    }

    return <div ref={containerRef} style={{ height: "100vh", width: "auto" }} />;
};

export default SupersetDashboardEmbed;
